// Module
var code = "<md-button ng-attr-md-autofocus=\"{{vm.focused || false}}\" ng-disabled=\"vm.isDisabled || vm.isProcessing\" aria-label=\"vm.label\" ng-class=\"[vm.styles ? vm.styles : 'md-raised md-accent md-hue-2']\" ng-click=\"vm.onButtonClick()\">\r\n\t<mx-icon ng-show=\"vm.icon\" icon=\"{{vm.icon}}\"></mx-icon>\r\n\t{{vm.label}}\r\n</md-button>\r\n";
// Exports
export default code;